
import './index.css'
import React, { useEffect, useState } from 'react';
function Home() {
	return (
		<>
		<div className="box">
			<div className="gg">
				此网站用于发布面试题及上传面试题文件。
				后续<a href="http://106.12.170.235/" target="_blank"> 嘻哩嘻哩 </a>网站中图床和动态板块也会迁移此站。
				<div className="js">前端技术栈 :  React / Ts / Hooks / Antd  </div>
				<div className="js">后端技术栈 :  Express / Mongodb / Redis / 腾讯云存储 / CDN服务 / 腾讯云开发</div>
				<div className="js">服务器代理 :  阿里云 / nginx</div>
				<div>产品意见及反馈 : <a href="https://support.qq.com/product/414579" target="_blank">吐小槽</a></div>
				<div>正在开发中...</div>
			</div>
		</div>
		</>
	)
}
export default Home